import React, { useState, useEffect } from "react";
import logo from "../logo.png";
import userIcon from "../user.png";
import { useNavigate } from "react-router-dom";

const Header = () => {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);

  const handleLogoClick = () => {
    window.history.back();
  };

  const handleLogout = () => {
    setShowModal(true);
  };

  const confirmLogout = () => {
    localStorage.removeItem("user");
    setShowModal(false);
    navigate("/");
  };

  const cancelLogout = () => {
    setShowModal(false);
  };
  const [kitchenId, setKitchenId] = useState("");

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user && user) {
      setKitchenId(user);
    }
  }, []);

  return (
    <>
      <header
        className="bg-white shadow-sm position-relative mb-3 mb-md-0"
        style={{
          borderBottom: "4px solid #007bff",
          height: "70px",
        }}
      >
        <div className="container-fluid d-flex align-items-center justify-content-between h-100 px-3">
          <div className="d-flex align-items-center">
            <span className="navbar-brand me-0 text-dark fs--2 fw-normal">
              <img
                src={logo}
                alt="logo"
                style={{ cursor: "pointer" }}
                onClick={handleLogoClick}
              />
            </span>
          </div>

          <div className="text-center flex-grow-1 d-none d-lg-block">
            <h5 className="fw-bold mb-0">Inventory Monitoring System</h5>
          </div>

          <div className="d-flex align-items-center gap-2">
            <span>{kitchenId.role}</span>
            <img
              src={userIcon}
              alt="User Icon"
              className="rounded-circle"
              height="40"
              width="40"
              style={{ cursor: "pointer" }}
              onClick={handleLogout}
            />
          </div>
        </div>
      </header>

      {/* Logout Confirmation Modal */}
      {showModal && (
        <div className="modal show d-block" tabIndex="-1">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Confirm Logout</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={cancelLogout}
                ></button>
              </div>
              <div className="modal-body">
                <p>Are you sure you want to logout?</p>
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={cancelLogout}>
                  Cancel
                </button>
                <button className="btn btn-danger" onClick={confirmLogout}>
                  Logout
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Header;
